import React from 'react';
import { useContextSelector } from 'use-context-selector';

import { TypeCardCheck } from '../../../../components/TypeCardCheck';
import { Typography } from '../../../../components/Typography';
import { ServiceContext } from '../../../../contexts/ServiceContext';
import { ProductItemProps } from '../../../../models/Product';
import { handleProductName } from '../../../../utils';
import { useProductListCheck } from './index.model';

import theme from '../../../../styles/theme';
import styled from 'styled-components';

const DivWrapper = styled.div`
  margin-bottom: 16px;

  &:not(:first-child) {
    margin-top: 16px;
  }
`;

export type HandleSelectProductProps = {
  product: ProductItemProps;
};

export type ProductCheck = {
  selected: boolean;
  disable: boolean;
} & ProductItemProps;

export type ProductListProps = {
  products: ProductCheck[];
  setProducts: (values: ProductCheck[]) => void;
  setProductList: (list: ProductItemProps[]) => void;
};

export const ProductListCheck: React.FC<ProductListProps> = ({ products, setProducts, setProductList }) => {
  const { selectedService } = useContextSelector(ServiceContext, state => state);

  const { handleSelectProduct } = useProductListCheck({
    products,
    setProducts,
    setProductList,
    selectedService
  });

  const disableProducts = products.filter(item => item.disable);
  const enableProducts = products.filter(item => !item.disable);

  return (
    <div>
      {enableProducts.length ? (
        <DivWrapper>
          <Typography color={theme.colors.colorGray400} fontWeight="500">
            Profissionais com agenda
          </Typography>
        </DivWrapper>
      ) : null}
      {enableProducts.map(product => (
        <TypeCardCheck
          key={product.id}
          title={handleProductName(product.name)}
          onClick={() => handleSelectProduct(product)}
          checked={product.selected}
          disable={product.disable}
        />
      ))}

      {disableProducts.length ? (
        <DivWrapper>
          <Typography color={theme.colors.colorGray400} fontWeight="500">
            Profissionais sem agenda
          </Typography>
        </DivWrapper>
      ) : null}

      {disableProducts.map(product => (
        <TypeCardCheck
          key={product.id}
          title={handleProductName(product.name)}
          onClick={() => {}}
          checked={product.selected}
          disable={product.disable}
        />
      ))}
    </div>
  );
};
